import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.scss';
import Header from "./common/Header"
import Footer from './common/Footer'
import Login from "./view/login/Login";
import ReconList from "./view/reconciliation/ReconList";



import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {

  return (
    <BrowserRouter>
      <Routes>
        {/* Login as landing page - no header/footer */}
        <Route path="/" element={<Login />} />

        {/* Protected routes with header/footer */}
        <Route path="/dashboard" element={
          <div>
            <Header />
            <ReconList />
            <Footer />
          </div>
        } />
      </Routes>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
    </BrowserRouter>
  );
}

export default App;

